/**
 * Add event listener to the document, returns the cleanup function for removing the listener.
 */
export function on<K extends keyof DocumentEventMap>(
  doc: Document,
  eventName: K,
  callback: (event: DocumentEventMap[K]) => void,
  options?: boolean,
): () => void;

/**
 * Add event listener to the window, returns the cleanup function for removing the listener.
 */
export function on<K extends keyof WindowEventMap>(
  win: Window,
  eventName: K,
  callback: (event: WindowEventMap[K]) => void,
  options?: boolean,
): () => void;

/**
 * Add event listener to the element, returns the cleanup function for removing the listener.
 */
export function on<K extends keyof HTMLElementEventMap>(
  element: Element,
  eventName: K,
  callback: (event: HTMLElementEventMap[K]) => void,
  options?: boolean,
): () => void;

/**
 * Add event listener to the element, returns the cleanup function for removing the listener.
 */
export function on(
  element: Element | Window | Document,
  eventName: string,
  callback: (event: Event) => void,
  options?: boolean,
): () => void {
  element.addEventListener(eventName, callback, options);

  return () => element.removeEventListener(eventName, callback, options);
}
